import { Link } from "react-router"
import { Button } from "@repo/ui"
import { useTranslation } from "react-i18next"
import { useGetEcommerceCompletitionStatusQuery } from "@/feature/financial-model/api"
import { Skeleton } from "@/components/ui/skeleton.tsx"
import { useDebugModeStore } from "@/global/store"

export const FinancialTablesLink = ({
  financialModelId,
}: {
  financialModelId: string
}) => {
  const { t } = useTranslation(`financialModel`)
  const { data } = useGetEcommerceCompletitionStatusQuery(financialModelId)

  const debugMode = useDebugModeStore((state) => state.mode)

  if (!data) {
    return <Skeleton className="w-24 h-6" />
  }
  const isDisabled =
    String(data.cogs.status) !== `100` || String(data.revenue.status) !== `100`
  return (
    <Link
      to={`/dashboard/financial-model/${financialModelId}/ecommerce/financial-tables`}
      aria-disabled={debugMode === `test` ? false : isDisabled}
      className={
        isDisabled
          ? `aria-disabled:cursor-not-allowed aria-disabled:pointer-events-none`
          : ``
      }
    >
      <Button
        variant="outline"
        size="md"
        disabled={debugMode ? false : isDisabled}
      >
        {t(`financial_model.library.home.financial_tables`)}
      </Button>
    </Link>
  )
}
